import getAppState from 'app-state';
import { CartOrder } from '../types';

/**
 * > **NOTE:** The current order is not a static object. It's properties can
 * > change throughout the lifetime of a session on the current page. This
 * > function can only return what state the current order was in when the
 * > page was initially loaded.
 */
const getCurrentOrder = () => getAppState<CartOrder>('currentOrder', null);

export default getCurrentOrder;
